import React, { useMemo } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import useLanguageChange from "../../../hooks/useLanguageChange";
import { buttonNotShowOnGORoom, checkScreenShareFeatureAvailable, handleClickOnStartScreenShare } from "./ScreenShareUtils";
import { CALL_BODY_SCREEN } from "../../../constants/Constants";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../../constants/PublicVariables";

const ScreenShareButton = () => {
    const { isRemoteParticipantJoined, currentCallBodyScreen } = useSelector((state) => state.commonReducer);
    const { isLocalUserScreenSharing, screenShareUnsupportedMsg } = useSelector((state) => state.twilioEvents);

    const localisedValues = useLanguageChange();

    const uploadFilesView = useMemo(() => {
        return currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN;
    }, [currentCallBodyScreen]);

    const isButtonDisabled = !isRemoteParticipantJoined || (screenShareUnsupportedMsg && !PublicVariables.isIOSDevice) || uploadFilesView;

    const isBtnVisible = () => {
        return checkScreenShareFeatureAvailable() && !(PublicVariables.isMobile && GLOBAL_MEETING_DATA.isAgent) && !buttonNotShowOnGORoom();
    };

    return (
        <>
            {isBtnVisible() && (
                <div className='action-button' data-testid='screenShare-button-component'>
                    <div className='action-button-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width'>
                        <button
                            className={clsx("call-action-btn", !isButtonDisabled && isLocalUserScreenSharing && "active")}
                            disabled={isButtonDisabled}
                            onClick={handleClickOnStartScreenShare}
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-share-screen'></span>
                            </span>
                            <span className='for-text'>
                                {isLocalUserScreenSharing ? localisedValues["stop_screen_share"] : localisedValues["start_screen_share"]}
                            </span>
                        </button>
                        {screenShareUnsupportedMsg && (
                            <div className='custom-tooltip-content text-nowrap'>
                                <div className='custom-tooltip-in'>
                                    <p>{screenShareUnsupportedMsg}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default ScreenShareButton;
